import { combineReducers } from 'redux';
import workflowReducer from './Workflow';
import customerReducer from './Customer';
import myTasksReducer from './MyTasksReducer';
import myRequests from './MyRequests';
import authReducer from './Auth';
import toastReducer from './Toast';
import updateFlowReducer from './UpdateFlowReducer';
import staticDataReducer from './StaticData';
import myPartners from './PartnersReducer';

const reducers = combineReducers({
    customer: customerReducer,
    workflows: workflowReducer,
    myTasks: myTasksReducer,
    myRequests,
    auth: authReducer,
    toasts: toastReducer,
    updateFlow: updateFlowReducer,
    staticData: staticDataReducer,
    myPartners,
});

export default reducers;
